import { Node_Type } from 'wix-rich-content-common';
import { Node_Type as Node_Type$1 } from 'ricos-types';
import React, { useContext } from 'react';
import { RicosViewerContext } from 'ricos-context';
import { Image } from 'wix-rich-content-ui-components';

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const DEFAULTS = Object.freeze({
  config: {
    size: "content",
    alignment: "center"
  },
  configViewer: {
    sizes: { desktop: "original", mobile: "original" }
    // original or downsizedSmall are supported
  }
});
const commonDesktopModalStyles = {
  width: "320px",
  boxSizing: "border-box",
  height: "364px",
  overflow: "visible",
  paddingRight: "12px",
  paddingLeft: "12px",
  display: "block",
  position: "absolute",
  zIndex: 6,
  paddingTop: "12px"
};
Object.freeze({
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0)",
    zIndex: 5
  },
  content: __spreadProps(__spreadValues$1({}, commonDesktopModalStyles), {
    border: "solid 1px rgba(51, 51, 51, 0.1)",
    boxShadow: "var(--ricos-settings-whitebox-box-shadow, 0 0 10px 0 rgba(0, 0, 0, 0.06))",
    borderRadius: "var(--ricos-settings-whitebox-border-radius, 2px)"
  })
});
({
  insert: `${Node_Type.GIF}.insert`,
  replace: `${Node_Type.GIF}.replace`
});
({
  alignment: `${Node_Type.GIF}.alignment`,
  size: `${Node_Type.GIF}.size`
});

const GIPHY_TYPE = "wix-draft-plugin-giphy";

var styles = {"giphy_player":"Sh6FR","gifRatio":"o2tI5"};

const ROOT = "giphyPlayer";

const GiphyViewer = (props) => {
  const { componentData } = props;
  const { id, width, height } = componentData;
  if (componentData.original.mp4) {
    return /* @__PURE__ */ React.createElement(
      "video",
      {
        role: "img",
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        "aria-label": "gif",
        "data-hook": ROOT,
        className: styles.giphy_player,
        src: componentData.original.mp4
      }
    );
  }
  const isInfoForWixImageReady = id !== void 0 && width !== void 0 && height !== void 0;
  if (isInfoForWixImageReady) {
    return /* @__PURE__ */ React.createElement(
      Image,
      {
        id,
        containerId: `${id}-parent`,
        role: "img",
        "aria-label": "gif",
        height,
        width,
        containerProps: {
          className: styles.gifRatio,
          containerId: `${id}-parent`,
          style: {
            ["--dim-height"]: height,
            ["--dim-width"]: width
          },
          dataHook: ROOT
        },
        displayMode: "fill",
        className: styles.giphy_player,
        uri: componentData.original.gif,
        alt: "gif"
      }
    );
  }
  return /* @__PURE__ */ React.createElement(
    "img",
    {
      role: "img",
      "aria-label": "gif",
      className: styles.giphy_player,
      src: componentData.original.gif,
      alt: "gif",
      "data-hook": ROOT
    }
  );
};

const Giphy = ({ node, nodeIndex, NodeViewContainer }) => {
  const { config } = useContext(RicosViewerContext);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { key: node.id, node, nodeIndex }, /* @__PURE__ */ React.createElement(GiphyViewer, { componentData: node.gifData, settings: config[GIPHY_TYPE] }));
};

const nodeViewRenderers = {
  [Node_Type$1.GIF]: Giphy
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginGiphy = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.configViewer), config),
    type: GIPHY_TYPE,
    nodeViewRenderers
  };
};

export { GIPHY_TYPE, pluginGiphy };
//# sourceMappingURL=viewer.js.map
